import { Box, Grid, Heading } from "@chakra-ui/react";

import { Event as ThreediEvent } from "@nens/threedi/openapi-client";

import { GridCard } from "../../components/GridCard";

import EventDetailsVisualisation from "./EventDetailsVisualisation";
import { BreachEvents } from "./events/BreachEvents";
import { LateralsEvent } from "./events/LateralsEvent";
import { TimeseriesRainEvent } from "./events/TimeseriesRainEvent";
import { WindEvents } from "./events/WindEvents";

type SimulationEventsDetailsProps = {
  duration: number;
  events: ThreediEvent;
};

function SimulationEventsDetails({ duration, events }: SimulationEventsDetailsProps) {
  return (
    <Box marginTop="18px">
      <Heading size="lg" marginBottom="8" marginTop="8">
        Events
      </Heading>
      <Grid gap="1rem" templateColumns="1fr 3fr">
        <TimeseriesRainEvent simulationDuration={duration} events={events.timeseriesrain} />
        <LateralsEvent simulationDuration={duration} events={events.laterals} />
        <WindEvents
          simulationDuration={duration}
          events={events.wind}
          windDragCoefficient={events.initialWinddragcoefficient}
        />
        {events?.savedstates && events.savedstates.length ? (
          <GridCard title="Saved states" variant="twocolumns">
            {events.savedstates.map((state) => state.name).join(", ")}
          </GridCard>
        ) : null}

        <BreachEvents simulationDuration={duration} events={events.breach} />
      </Grid>
      <EventDetailsVisualisation type="simulation" events={events} />
    </Box>
  );
}

export default SimulationEventsDetails;
